// extracted by mini-css-extract-plugin
export default {"wrap":"MealsListComponent_wrap__gVMrx"};